import { api } from "./api";

export const reportStudent = async (params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<any> => {
  const { data } = await api.get("/report/student", { params });
  return data;
};

export const reportFrequency = async (params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<any> => {
  const { data } = await api.get("/report/frequency", { params });
  return data;
};

export const reportFinance = async (params: {
  startDate: Date;
  endDate: Date;
}): Promise<any> => {
  const { data } = await api.get("/report/finance", { params });
  return data;
};
